import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { SessionsPostCardStackContentViewModel } from './sessions-post-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-sessions-post-card-stack-content',
  templateUrl: './sessions-post-card-stack-content.component.html',
  styleUrls: ['./sessions-post-card-stack-content.component.scss'],
  providers: [SessionsPostCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SessionsPostCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public viewModel: SessionsPostCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
